import ExpandedSectionHeader from './ExpandedSectionHeader';
import { ExpandedSectionHeaderProps, ExpandedSectionHeaderValueProps } from './types';

export type { ExpandedSectionHeaderProps, ExpandedSectionHeaderValueProps };
export default ExpandedSectionHeader;
